import AuthService from "../../../../services/auth.service";

import "./userFormUpdate.scss";

const UserFormUpdate = (props) => {
  if (!AuthService.getSubscription()) {
    return <></>;
  }

  if (AuthService.getSubscription().is_user_form_update) {
    return <></>;
  }

  return false;
};

export default UserFormUpdate;
